// extracted by mini-css-extract-plugin
export default {"Container":"Audit_Container__IPF6G","content":"Audit_content__QG5xA","section-1":"Audit_section-1__t2Jwx","section-2":"Audit_section-2__XUcj0"};